module.exports = __webpack_public_path__ + "src/img/zalando/img-zalando-websites.1aae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-zalando-websites.jpg
// module id = 269
// module chunks = 0